export enum SendGridEventStatus {
  BLOCKED = "blocked",
  BOUNCE = "bounce",
  CLICK = "click",
  DEFERRED = "deferred",
  DELIVERED = "delivered",
  DROPPED = "dropped",
  FAILED = "failed",
  GROUP_RESUBSCRIBE = "group_resubscribe",
  GROUP_UNSUBSCRIBE = "group_unsubscribe",
  OPEN = "open",
  PROCESSED = "processed",
  SPAM_REPORT = "spamreport",
  UNSUBSCRIBE = "unsubscribe",
}

export const pendingStatuses: SendGridEventStatus[] = [
  SendGridEventStatus.PROCESSED,
  SendGridEventStatus.DEFERRED,
];
export const deliveredStatuses: SendGridEventStatus[] = [
  SendGridEventStatus.DELIVERED,
  SendGridEventStatus.OPEN,
  SendGridEventStatus.CLICK,
];
export const failedStatuses: SendGridEventStatus[] = [
  SendGridEventStatus.BOUNCE,
  SendGridEventStatus.DROPPED,
  SendGridEventStatus.BLOCKED,
  SendGridEventStatus.SPAM_REPORT,
  SendGridEventStatus.UNSUBSCRIBE,
  SendGridEventStatus.GROUP_UNSUBSCRIBE,
  SendGridEventStatus.GROUP_RESUBSCRIBE,
];
